export const LICENSE_STATUS = {
  NONE: 'no license',
  VALID: 'valid license',
  SHOW_ADMIN_LICENSE_WARNING: 'display admin license warning',
  SHOW_LICENSE_WARNING: 'display license warning',
  EXPIRED: 'license expired',
  UNKNOWN: 'unknown status',
};
export const WARNING_FLAGS = {
  STANDARD: {
    SHOW_ADMIN_WARNING_DAYS_COUNT: 60,
    SHOW_WARNING_DAYS_COUNT: 30,
  },
  TRIAL: {
    SHOW_ADMIN_WARNING_DAYS_COUNT: 30,
    SHOW_WARNING_DAYS_COUNT: 10,
  },
};

/*
 * This list is for convenience within Webserver to reference known licensed features. It is not strictly
 * necessary to add to this list, you can refer to the feature by string (instead of this enum).
 * The master list is the "salesforce_to_seeq_mapping" variable in licensing.py.
 */
export enum Feature {
  ODATA_Realtime_Export,
  Data_Lab,
  WITSML_Connector,
  AF_Data_Reference,
  Audit_Trail,
  Seeq_Connector_Plus_PI_EF,
  Asset_Group,
  Marketplace_6001,
  Marketplace_6002,
  Marketplace_6003,
  Marketplace_6004,
  Marketplace_6005,
  Marketplace_6006,
  Marketplace_6007,
  Marketplace_6008,
  Marketplace_6009,
  Marketplace_6010,
  Seeq_Preview,
  ThirdParty_DataSharing,
  Vantage,
  Locking,
  Agent_Q,
  Agent_Builder,
  Scaling_Tables,
}
